import { create } from 'zustand';

import { Schedule } from '@/features/calendar/types';

export type FilterType = {
  variant?: Schedule.Lesson['variant'];
  status?: Schedule.Lesson['status'];
};

export type FilterOptions = {
  force?: boolean;
};

type SchedulePageStore = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedMonth: string;
  setSelectedMonth: (selectedMonth: string) => void;
  filter: FilterType;
  setFilter: (filter: FilterType, options?: FilterOptions) => void;
  resetFilters: () => void;
};

export const useSchedulePageStore = create<SchedulePageStore>(set => ({
  isOpen: false,
  setIsOpen: (isOpen: boolean) => set({ isOpen }),
  selectedMonth: 'Select all',
  setSelectedMonth: (selectedMonth: string) => set({ selectedMonth }),
  filter: {},
  setFilter: (filter: FilterType, options?: FilterOptions) => {
    const { variant, status } = filter;
    if (variant) {
      set(prev => {
        if (prev.filter?.variant === variant && !options?.force) {
          return { ...prev, filter: {} };
        }
        return { ...prev, filter: { variant } };
      });
    } else if (status) {
      set(prev => {
        if (prev.filter?.status === status && !options?.force) {
          return { ...prev, filter: {} };
        }
        return { ...prev, filter: { status } };
      });
    }
  },
  resetFilters: () => set({ selectedMonth: 'Select all', filter: {} }),
}));
